// Keeps the fixed archive menu readable while the page moves underneath it.
// Text turns dark over light bands; the logo shows white over
// flat colour and switches to its original red whenever a photo sits behind it.
class KmNavTone extends HTMLElement {
  connectedCallback() {
    this.nav = document.getElementById(this.getAttribute('target') ?? '');
    if (!this.nav) return;
    this.logo = this.nav.querySelector('[data-nav-logo]');
    this.controller = new AbortController();
    const options = { passive: true, capture: true, signal: this.controller.signal };
    // Capture catches the sideways image strips scrolling too, not just the page.
    window.addEventListener('scroll', () => this.schedule(), options);
    window.addEventListener('resize', () => this.schedule(), options);
    window.addEventListener('load', () => this.schedule(), options);
    this.update();
  }

  disconnectedCallback() {
    this.controller?.abort();
    if (this.frame) cancelAnimationFrame(this.frame);
  }

  schedule() {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = 0;
      this.update();
    });
  }

  update() {
    if (!this.nav) return;
    const probe = this.nav.getBoundingClientRect().top + 30;
    const lightAreas = document.querySelectorAll('[data-nav-tone="dark"]');
    const overLight = Array.from(lightAreas).some((area) => {
      const rect = area.getBoundingClientRect();
      return rect.top <= probe && rect.bottom >= probe;
    });
    this.nav.dataset.tone = overLight ? 'dark' : 'light';
    this.nav.dataset.logo = overLight || this.logoOverPhoto() ? 'red' : 'white';
  }

  logoOverPhoto() {
    if (!this.logo) return false;
    const rect = this.logo.getBoundingClientRect();
    if (!rect.width) return false;
    const y = rect.top + rect.height / 2;
    // Switches once a photo covers the middle of the logo, so it never turns red over the red panel.
    const xs = [rect.left + rect.width * 0.5];
    return xs.some((x) =>
      document
        .elementsFromPoint(x, y)
        .some((el) => !this.nav.contains(el) && (el.tagName === 'IMG' || el.tagName === 'VIDEO' || el.tagName === 'IFRAME'))
    );
  }
}

if (!customElements.get('km-nav-tone')) customElements.define('km-nav-tone', KmNavTone);
